module.exports = __webpack_public_path__ + "static/img/4-13.d3729f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/zoology/4-13.png
// module id = lU93
// module chunks = 15